// extracted by mini-css-extract-plugin
module.exports = {"footerContainer":"ClientWallet_footerContainer__wT0mp","savePackageButton":"ClientWallet_savePackageButton__38g8a"};